<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Coupons",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Coupons",
            items: [
               {
                  text: "Coupons",
                  active: true,
               },                   
            ],

            

            coupons: [],
            coupon: {
               id: null,
               coupon_name : "",
               coupon_code: "",
               type: "",
               coupon_for: "",
               amount: '',
               count: "",
               expiry_date: "",
            },
            
            modal_title: "Add Coupon",
            button_title: "Save",
            pagination: {},
            edit: false,
            coupon_status: {
               id: "",
               status: "",
            },
            listing_length: 10,
            keyword: '',
            status: '',
            token: "",

            code: '',

            errors: {},
            activate: false,
            deactivate: false,
            
            loading: false,

            active_page_url: null,
         };
      },
      mounted() {
         this.clearLocalStorage();

      },

      created() {
         this.fetchCoupons();
      },

      methods: {
         clearLocalStorage() {
            localStorage.removeItem("consultation_filters");
            localStorage.removeItem("cancel_consultation_filters");
            localStorage.removeItem("patient_filters");
            localStorage.removeItem("doctor_filters");

         },

         fetchCoupons(page_url = null) {

            this.getToken();
            let url = "api/admin/coupon/index?keyword=" + this.keyword + "&limit=" + this.listing_length + "&status=" + this.status;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;
            
            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.coupons = responseData.coupons.data;
                  
                  this.pagination = responseData.coupons.links;
                  this.from = responseData.coupons.from;
                  this.to = responseData.coupons.to;
                  this.total = responseData.coupons.total;
               
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         }, 

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },

         setCode() {
            var str = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
            this.coupon.coupon_code = Array(10).fill(str).map(function(x) { return x[Math.floor(Math.random() * x.length)] }).join('');
            this.showModal("coupon-modal");
         },

         editCoupon(coupon) {          
            this.modal_title = "Edit Coupon";
            this.button_title = "Update";
            this.coupon.id = coupon.id;
            this.coupon.coupon_name = coupon.coupon_name;
            this.coupon.coupon_code = coupon.coupon_code;
            this.coupon.type = coupon.type;
            this.coupon.coupon_for = coupon.coupon_for;
            this.coupon.amount = coupon.amount;
            this.coupon.count = coupon.count;
            this.coupon.expiry_date = coupon.expiry_date;
            this.edit = true;
            this.showModal("coupon-modal");
         },
         clearForm() {           
            
            this.modal_title = "Add Coupon";
            this.button_title = "Add";
            this.coupon.id = "";
            this.coupon.coupon_name = "";
            this.coupon.coupon_code = "";
            this.coupon.type = "";
            this.coupon.coupon_for = "";
            this.coupon.amount = '';
            this.coupon.count = "";
            this.coupon.expiry_date = "";
            this.edit = false;

            this.errors = {};
         },

         addCoupon() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url;
            let formData = new FormData();

            if(!this.edit) {
               url = "api/admin/coupon/store";
               this.active_page_url = null;

            } else {
               url = "api/admin/coupon/update";
               formData.append("id", this.coupon.id); 
            }         

            formData.append("coupon_name", this.coupon.coupon_name); 
            formData.append("coupon_code", this.coupon.coupon_code); 
            formData.append("type", this.coupon.type); 
            formData.append("coupon_for", this.coupon.coupon_for); 
            
            
            formData.append("count", this.coupon.count); 
            formData.append("expiry_date", this.coupon.expiry_date); 

            if(this.coupon.type == 1) {
               formData.append("amount", this.coupon.amount); 
            } else {
               formData.append("percentage", this.coupon.amount); 
            }

         
            this.loading = true;
            
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.hideModal('coupon-modal');
                  this.fetchCoupons(this.active_page_url);
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         activateCoupon(coupon) {
            this.activate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to publish this Coupon?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
              .then(value => {
                  this.activate = value
                  if(this.activate){
                  this.coupon_status.id = coupon.id;
                  this.coupon_status.status = 1;
                  this.updateCouponStatus();
               }
              })
               .catch(err => {
                  console.log(err);
              })
         },
         deactivateCoupon(coupon) {
            this.deactivate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to unpublish this Coupon?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
               .then(value => {
                  this.deactivate = value
                  if(this.deactivate){
                  this.coupon_status.id = coupon.id;
                  this.coupon_status.status = 2;
                  this.updateCouponStatus();
               }
               })
               .catch(err => {
                  console.log(err);
               })
         },
         updateCouponStatus() {
            
            this.getToken();
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };     

            var data = JSON.stringify({
               "id": this.coupon_status.id,
               "status": this.coupon_status.status
            });

            let url = "api/admin/coupon/status";
            this.$axios
               .put(url, data, config)
               .then((response) => {                  
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.fetchCoupons(this.active_page_url);
               })
               .catch((error) => {                
                  if (error.response) {
                     if (error.response.data.message) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               });
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <b-button variant="primary" class="float-end" @click="setCode()">Add Coupon</b-button>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchCoupons()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchCoupons()"/>
                           </label>
                        </div>                     
                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="status" @change="fetchCoupons()">
                                 <option value="">All</option>
                                 <option value="1">Published</option>
                                 <option value="2">Unpublished</option>
                              </select>
                           </label>
                        </div>   
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                               
                           <tr>
                              <th>Name</th>  
                              <th>Code</th>  
                              <th>Type</th> 
                              <th>Amount/<br>Percentage</th>
                              <th>Coupon For</th>
                              <th>Count</th>
                              <th>Expiry</th>      
                              <th>Created on</th>
                              <th>Options</th>                             
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(coupons.length)">
                           <tr v-for="(coupon) in coupons" :key="coupon.id">
                              <td>{{coupon.coupon_name}}</td>
                              <td>{{coupon.coupon_code}}</td>
                              <td>
                                 <span v-if="coupon.type==1">Amount</span>
                                 <span v-if="coupon.type==2">Percentage</span>
                              </td>
                              <td>
                                 <span v-if="coupon.type==1">Rs. {{coupon.amount}}</span>
                                 <span v-if="coupon.type==2">{{coupon.amount}}%</span>
                              </td>
                              <td>
                                 <span v-if="coupon.coupon_for==1">Pharmacy Orders</span>
                                 <span v-if="coupon.coupon_for==2">Video Consultation</span>
                                 <span v-if="coupon.coupon_for==3">Offline Consultation</span>
                              </td>
                              <td>{{coupon.count}}</td>
                              <td>{{coupon.expiry_date | formatDate}}</td>
                              <td>{{coupon.converted_created_at}}</td>
                              <td>
                                 <b-button variant="primary" class="btn-sm me-2 mt-2" @click="editCoupon(coupon)">Edit</b-button>

                                 <router-link :to="{ name: 'coupons.logs', params: {id: coupon.id} }" class="btn btn-primary me-2 mt-2 btn-sm">Logs</router-link>

                                 <b-button v-if="coupon.status==1" variant="danger" class="btn-sm mt-2 me-2" @click="deactivateCoupon(coupon)">Unpublish</b-button>

                                 <b-button v-else variant="success" class="btn-sm mt-2 me-2" @click="activateCoupon(coupon)">Publish</b-button>
                              </td>
                           </tr>
                 
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="6" class="text-center">No coupons found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts ---> 
                  <caption v-if="Boolean(coupons.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchCoupons(page.url + '&limit='+ listing_length + '&keyword=' + keyword + '&status=' + status )">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->
                  
                  <!---- modal starts ---->
                  <b-modal ref="coupon-modal" id="coupon-modal" :title="modal_title" hide-footer @hidden="clearForm()">
                     <b-form @submit.prevent="addCoupon()">
                        <b-row>
                           <b-col md="12" class="form-group">
                              <label class="control-label">Name<span class="text-danger">*</span></label>
                              <b-form-input v-model="coupon.coupon_name" v-bind:class="{ 'is-invalid': Boolean(errors.coupon_name) }"></b-form-input>

                              <div v-for="(val, index) in errors.coupon_name" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col> 

                           <b-col md="12" class="form-group">
                              <label class="control-label">Coupon for<span class="text-danger">*</span></label>
                              <b-form-radio-group v-model="coupon.coupon_for" v-bind:class="{ 'is-invalid': Boolean(errors.coupon_for) }">
                                 <div class="form-check-inline">
                                    <b-form-radio name="coupon_for"  :value="1">Pharmacy Orders</b-form-radio> 
                                 </div>  
                                 <div class="form-check-inline">
                                    <b-form-radio name="coupon_for" :value="2">Video Consultation</b-form-radio>
                                 </div>
                                 <div class="form-check-inline">
                                    <b-form-radio name="coupon_for" :value="3">Offline Consultation</b-form-radio>
                                 </div>
                              </b-form-radio-group>

                              <div v-for="(val, index) in errors.coupon_for" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>    


                           <b-col md="12" class="form-group">
                              <label class="control-label">Type<span class="text-danger">*</span></label>
                              <b-form-radio-group v-model="coupon.type" v-bind:class="{ 'is-invalid': Boolean(errors.type) }">
                                 <div class="form-check-inline">
                                    <b-form-radio name="coupon_type"  :value="1">Amount</b-form-radio> 
                                 </div>
                                 <div class="form-check-inline" v-if = "coupon.coupon_for!==2"> 
                                    <b-form-radio name="coupon_type" :value="2">Percentage</b-form-radio>
                                 </div>
                              </b-form-radio-group>

                              <div v-for="(val, index) in errors.type" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="6" class="form-group">
                              <label class="control-label">Code<span class="text-danger">*</span></label>
                              <b-form-input v-model="coupon.coupon_code" v-bind:class="{ 'is-invalid': Boolean(errors.coupon_code) }"></b-form-input>

                              <div v-for="(val, index) in errors.coupon_code" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="6" class="form-group" v-if="coupon.type==1 || coupon.type==2">
                              <label v-if="coupon.type==1" class="control-label">Amount (in Rs)<span class="text-danger">*</span></label>
                              <label v-else class="control-label">Percentage<span class="text-danger">*</span></label>
                              <b-form-input v-model="coupon.amount" v-bind:class="{ 'is-invalid': Boolean(errors.amount) || Boolean(errors.percentage) }"></b-form-input>

                              <div v-for="(val, index) in errors.amount" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>

                              <div v-for="(val, index) in errors.percentage" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <!-- <b-col md="6" class="form-group" v-if="coupon.type==2">
                              <label class="control-label">Percentage<span class="text-danger">*</span></label>
                              <b-form-input v-model="coupon.percentage" v-bind:class="{ 'is-invalid': Boolean(errors.percentage) }"></b-form-input>

                              <div v-for="(val, index) in errors.percentage" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col> -->

                           <b-col md="6" class="form-group">
                              <label class="control-label">Count<span class="text-danger">*</span></label>
                              <b-form-input v-model="coupon.count" v-bind:class="{ 'is-invalid': Boolean(errors.count) }"></b-form-input>
                              <div v-for="(val, index) in errors.count" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="6" class="form-group">
                              <label class="control-label">Expiry<span class="text-danger">*</span></label>
                              <!-- <b-form-datepicker v-model="coupon.expiry" v-bind:class="{ 'is-invalid': Boolean(errors.expiry) }"></b-form-datepicker> -->
                              <input type="date" class="form-control" v-model="coupon.expiry_date"  v-bind:class="{ 'is-invalid': Boolean(errors.expiry_date) }"/>
                              <div v-for="(val, index) in errors.expiry_date" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                           
                           <b-col md="12">
                              <b-button type="submit" class="me-3" variant="primary" :disabled="loading">
                                 <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                 {{ loading ? 'Saving...' : button_title }}
                              </b-button>
                              <b-button class="" variant="light" @click="hideModal('coupon-modal')" :disabled="loading">Close</b-button>
                           </b-col>
                        </b-row>
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
